import * as constants from 'utils/constants'
import {
  BLACK,
  BLACK_20,
  BLACK_50,
  BLACK_75,
  BLACK_80,
  BLUE,
  BLUE_ALT,
  BLUE_DARK,
  GREEN,
  GREEN_ALT,
  GREY,
  GREY_DARK,
  GREY_DARKER,
  GREY_DARKEST,
  GREY_LIGHT,
  LIGHT_BLUE_50,
  ORANGE,
  RED,
  SKY_BLUE_50,
  TRANSPARENT,
  WHITE,
} from 'utils/constants/colors'
import { MAX_WIDTH } from 'utils/constants/maxWidth'

export const baseTheme = {
  maxWidth: MAX_WIDTH,
  fonts: {
    weights: {
      thin: 100,
      extraLight: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      black: 900,
    },
    sizes: {
      xs: 11,
      sm: 14,
      md: 18,
      lg: 24,
      xl: 32,
      xxl: 64,
      xxxl: 100,
    },
    header: constants.fonts.HEADER_FONT,
    body: constants.fonts.PARAGRAPH_FONT,
    bodyBold: constants.fonts.PARAGRAPH_FONT_BOLD,
  },

  buttons: {
    sizes: {
      xs: 32,
      sm: 40,
      md: 60,
    },
  },

  spacing: {
    none: 0,
    xxs: 2,
    xs: 4,
    sm: 8,
    smd: 12,
    md: 16,
    lg: 24,
    xl: 32,
  },

  borderRadius: {
    xs: 4,
    sm: 8,
    md: 16,
    xl: 30,
  },

  border: {
    xs: 1,
    sm: 2,
  },

  shadow: {
    sm: `0px 0px 12px rgba(0, 0, 0, 0.5)`,
    md: `0px 4px 12px rgba(0, 0, 0, 0.1)`,
    xl: `0 2.8px 2.2px rgba(0, 0, 0, 0.034)`,
  },

  colors: {
    primary: BLUE,
    primaryAlt: BLUE_ALT,
    primaryDark: BLUE_DARK,
    secondary: GREEN,
    secondaryAlt: GREEN_ALT,
    text: BLACK,
    textHighlight: BLUE_ALT,
    textInverted: WHITE,
    textSubtle: GREY_DARKER,
    grey: GREY,
    greyDark: GREY_DARK,
    greyDarker: GREY_DARKER,
    greyDarkest: GREY_DARKEST,
    greyLight: GREY_LIGHT,
    black: BLACK,
    black20: BLACK_20,
    black50: BLACK_50,
    black75: BLACK_75,
    black80: BLACK_80,
    white: WHITE,
    error: RED,
    warn: ORANGE,
    transparent: TRANSPARENT,
    v2primary: '#4578F1',
    v2grey: '#2C2C2A',
    v2black: '#1F1E1E',
    v2accent: '#00FFFF',
    v2midGrey: '#A9A9A9',
    v2secondary: '#F91D75',
    v2lightGrey: '#F5F5F5',
  },
  gradients: {
    primary: {
      start: SKY_BLUE_50,
      end: LIGHT_BLUE_50,
    },
  },
}
